'use client'

import * as React from 'react'

import { buttonVariants, cn, LocalizedLink, useLocale } from '@rewardops/ui'

import { useApi } from '~/components/hooks/use-api'
import { useCategoriesWithUrls } from '~/components/hooks/use-categories-with-urls'
import { useTenantStyles } from '~/components/hooks/use-tenant-styles'
import ResponsiveComponent from '~/components/responsive-component'
import { MobileNav } from '../mobile-nav'
import { BirchLogo } from './birch-logo'

export function BirchMainNav() {
  const { api, tenant } = useApi()
  const { locale } = useLocale()
  const { data, isLoading } = api.categories.getAll.useQuery()
  const categories = data?.rootCategory?.children
  const tenantStyles = useTenantStyles()
  const hoverStyles = useTenantStyles({ hover: true })
  const { showProducts, roRootCategory } = tenant
  const categoriesList = useCategoriesWithUrls(
    showProducts,
    categories,
    roRootCategory,
    locale,
  )

  if (isLoading) {
    return null
  }
  if (!categoriesList || !data) return null

  return (
    <header className="sticky top-0 z-40" {...tenantStyles}>
      <ResponsiveComponent
        mobileComponent={<MobileNav categories={categories} />}
        desktopComponent={
          <DesktopNav
            categories={categoriesList}
            locale={locale}
            tenantStyles={tenantStyles}
            hoverStyles={hoverStyles}
          />
        }
      />
    </header>
  )
}

const DesktopNav = ({
  categories,
  locale,
  tenantStyles,
  hoverStyles,
}: {
  categories: any
  locale: any
  tenantStyles: any
  hoverStyles: any
}) => {
  return (
    <div className="container flex h-12 w-full justify-center py-2">
      <div className="flex w-full max-w-4xl justify-between">
        <BirchLogo />
        {categories.map(
          ({ category, categoryUrl }: { category: any; categoryUrl: any }) => (
            <LocalizedLink
              id={`nav-bar-${category.code}`}
              key={category.code}
              href={categoryUrl}
              className={cn(
                buttonVariants(),
                'relative top-[-3px] text-black opacity-80 hover:text-black hover:opacity-100',
              )}
              {...hoverStyles}
            >
              {category.name[locale]}
            </LocalizedLink>
          ),
        )}
      </div>
    </div>
  )
}
